var Privacy;
(function (Privacy) {
  Privacy["Private"] = 'private';
  Privacy["Public"] = 'public';
  Privacy["Stealth"] = 'stealth';
})(Privacy || (Privacy = {}));
var DefaultPrivacyLevels;
(function (DefaultPrivacyLevels) {
  DefaultPrivacyLevels["Private"] = "Private";
  DefaultPrivacyLevels["Public"] = "Public";
  DefaultPrivacyLevels["Stealth"] = "Stealth";
})(DefaultPrivacyLevels || (DefaultPrivacyLevels = {}));
export { DefaultPrivacyLevels, Privacy };